module.exports = __webpack_public_path__ + "static/images/hero.8024635ce7f0a8088f0f4fd16bac6429.jpg";